module.exports = __webpack_public_path__ + "static/media/change_password.5218886e.svg";